<div class="payment-callback-container">
    <div class="callback-card">
        <!-- Processing State -->
        <div *ngIf="status === 'processing'" class="status-content">
            <div class="spinner"></div>
            <h2>{{ "payment-callback.verifying" | translate }}</h2>
            <p>{{ "payment-callback.please-wait" | translate }}</p>
        </div>

        <!-- Success State -->
        <div *ngIf="status === 'success'" class="status-content">
            <div class="success-icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>
            <h2>{{ "payment-callback.success" | translate }}</h2>
            <p>{{ "payment-callback.payment-verified" | translate }}</p>
            <p class="redirect-message">
                {{ "payment-callback.redirecting" | translate }}
            </p>
        </div>

        <!-- Error State -->
        <div *ngIf="status === 'error'" class="status-content">
            <div class="error-icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
            </div>
            <h2>{{ "payment-callback.error" | translate }}</h2>
            <p class="error-message">{{ errorMessage }}</p>
            <div class="action-buttons">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="onCancel()"
                >
                    {{ "payment-callback.back-to-assignments" | translate }}
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="onRetry()"
                    *ngIf="sessionId"
                >
                    {{ "payment-callback.retry" | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
